.checkboxRow {
    display: flex;
    align-items: center;
    margin: 10px 0;
}

.formField {
    margin-bottom: 16px;
}

.unacceptableCheckbox {
    display: flex;
    align-items: center;
    margin-left: 8px;
    margin-right: 8px;
}

.optionInput {
    flex: 1;
}

.optionRow {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 8px;
}

.optionsContainer {
    margin-top: 8px;
    margin-bottom: 8px;
}
